import { isGPSMode } from '@/_utils/card'
import { isCardOff } from '@/_utils/card'

import UserModel from '@/_models/UserModel'
import CardModel from '@/_models/CardModel'
import BeaconModel from '@/_models/BeaconModel'
import NaviModel from '@/_models/NaviModel'

type ClearType = 'beacons' | 'gps' | 'all'

function getLocationByKeyDatas<T>(
  datas: Array<BeaconModel | CardModel>,
  user: T,
  localeKey: string,
  compareKey: string
) {
  const info: string[] = []
  const matched = datas.find(data => data[localeKey] === user[compareKey])

  if (matched && matched.location_name) {
    info.push(matched.location_name)
  }

  if (matched && matched.floor_name) {
    info.push(matched.floor_name)
  }

  return info.join(', ')
}

export const getLocationTextCarriedCard = (user: UserModel, beacons: BeaconModel[]) => {
  return getLocationByKeyDatas<UserModel>(beacons, user, '_id', 'nearest_beacon_id')
}

export const getLocationTextCarriedBeacon = (user: UserModel, cards: CardModel[]) => {
  // User holding a carried beacon
  // user.san_id same with user.nearest_beacon_id in card carried case
  return getLocationByKeyDatas<UserModel>(cards, user, '_id', 'nearest_card_id')
}

export const getLocationTextNavi = (user: NaviModel, cards: CardModel[]) => {
  return getLocationByKeyDatas<NaviModel>(cards, user, 'san_id', 'san_id')
}

export const getUserLocationText = (user: UserModel, beacons: BeaconModel[], cards: CardModel[]) => {
  // User holding a carried beacon
  if (user.nearest_card_id) {
    return getLocationTextCarriedBeacon(user, cards)
  }

  // User hoding a carried card
  if (user.nearest_beacon_id) {
    return getLocationTextCarriedCard(user, beacons)
  }

  return ''
}

export const getUserLonLatText = (user: UserModel): string => {
  return isGPSMode(user) ? `${user.lat}, ${user.lon}` : ''
}

export const addCurrentLocationToUser = (newUser: UserModel, beacons: BeaconModel[], cards: CardModel[]) => {
  const currentLocation = newUser.is_outside ? getUserLonLatText(newUser) : getUserLocationText(newUser, beacons, cards)

  return {
    ...newUser,
    current_location_name: !isCardOff(newUser) ? currentLocation : '',
    is_outside: !!newUser.is_outside,
  }
}
